import { createNamespace, isDef } from '../utils';
import Avatar from '../avatar';
import Row from '../row';
import Tag from '../tag';

var _createNamespace = createNamespace('person-card'),
    createComponent = _createNamespace[0],
    bem = _createNamespace[1];

export default createComponent({
  props: {
    avatarFigure: {
      type: [String, Number],
      default: 1
    },
    avatarSize: {
      type: [Number, String],
      default: 50
    },
    avatarRadius: [Number, String],
    title: String,
    subTitle: String,
    tag: String,
    tagType: String,
    corner: String,
    content: [String, Array]
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var slots = this.slots;
    var genAvatar = h("div", {
      "class": bem('avatar')
    }, [slots('avatar') || h(Avatar, {
      "attrs": {
        "figure": this.avatarFigure,
        "size": this.avatarSize,
        "radius": this.avatarRadius
      }
    })]);
    var genBase = h(Row, {
      "attrs": {
        "type": "flex",
        "align": "center",
        "justify": "space-between"
      },
      "class": bem('base')
    }, [h(Row, {
      "attrs": {
        "type": "flex",
        "align": "center"
      }
    }, [slots('title') || h("div", [isDef(this.title) && h("span", {
      "class": bem('title')
    }, [this.title]), isDef(this.subTitle) && h("span", {
      "class": bem('sub-title')
    }, [this.subTitle])]), this.slots('tag') || this.tag && h(Tag, {
      "attrs": {
        "type": this.tagType,
        "round": true
      }
    }, [this.tag])]), h("div", [this.slots('corner') || h("span", {
      "class": bem('corner')
    }, [this.corner])])]);
    var genContent = h("div", {
      "class": bem('content')
    }, [slots() || typeof this.content === 'string' ? h("span", {
      "class": "van-multi-ellipsis--l1"
    }, [this.content]) : this.content.map(function (item, index) {
      return h("span", {
        "class": bem('content-item')
      }, [item, h("i", {
        "directives": [{
          name: "show",
          value: index !== _this.content.length - 1
        }],
        "class": bem('gap')
      })]);
    })]);
    return h("div", {
      "attrs": {
        "role": "person-card"
      },
      "class": bem()
    }, [genAvatar, h("div", {
      "class": bem('wrapper')
    }, [genBase, genContent])]);
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant-green/es/person-card/index.js
// module id = null
// module chunks = 